import { module } from 'modujs';
import { createNoise3D } from 'simplex-noise';
import { gsap } from 'gsap';
import { onRAF } from '../utils/onRaf.js';

let noise3D = createNoise3D();
const clamp = (value, min, max) => Math.max(Math.min(value, max), min);

export default class extends module {
	constructor(m) {
		super(m);

		this.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

	}

	init() {
		this.yStart = this.isMobile ? 0.6 : 0.52;
		this.yAlphaOffset = this.isMobile ? 0.7 : 0.65;

		this.timeRatio = this.isMobile ? 2 : 1.5;
		this.canvas = document.createElement('canvas');
		this.ctx = this.canvas.getContext('2d');
		this.ctx.translate(0.5,0.5);

		this.el.appendChild(this.canvas);
		this.resizeDebounce(true);

		this.deltaTime = performance.now();
		this.iterator = 0;
		this.unregisterRAF = onRAF(() => this.draw());

		this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);

		this.msPrev = performance.now();

	}

	initLines() {
		this.xFrequency = 0.8 * this.w / 1000;
		this.yFrequency = 8 * this.h / 1000;

		this.linesCount = parseInt(this.bh/10);
		// this.linesCount = 20;
		this.offset = 180;

		this.steps = Math.ceil(this.bw/10);
		// this.steps = 20;
		this.gapWidth = Math.ceil(this.bw / this.steps);
		this.gapHeight = Math.ceil((this.bh * 1.5) / this.linesCount);

		this.gapIterator = this.gapHeight;

		this.lineIterator = 0;
		this.lines = [];

		
		
	}	

	addLine() {
		// console.timeEnd("add line");
		this.lineIterator--;

		let step = [
			0,
			this.yStart,
			0, // progress of the y position
			this.lineIterator, // noise iterator
			0,// progress
		];

		this.lines.unshift(step);

		if(this.lines.length > this.linesCount) {
			this.lines.pop(this.linesCount,this.lines.length - this.linesCount);
			this.gapIterator = 0;
		}
		
		// console.time("add line");
	}

	draw() {
		this.ctx.clearRect(0,0,this.w, this.h);
		// this.ctx.fillStyle = 'white';
		// this.ctx.fillRect(0,0,this.w, this.h);

		this.deltaTime+=0.005;

		if(this.gapIterator * (this.bh - this.offset*2) > this.gapHeight) {
			this.addLine();
			// console.log(this.gapIterator * this.bh);

			this.gapIterator = 0;
		} else {
			this.gapIterator += 0.001 * this.timeRatio;
		}
		
		let timedOffset = 1;

		this.ctx.beginPath();
		this.ctx.strokeStyle = 'white';
		this.ctx.lineWidth = 5;
		this.ctx.moveTo(0,0);
		this.ctx.lineTo(this.w/2, this.h/2 + Math.cos(this.deltaTime) * 200);
		// this.ctx.stroke();
		this.ctx.closePath();

		this.lines.forEach((step, stepIndex) => {
			
			let x = 0;
			let lastPosition = [0,0];

			this.ctx.beginPath();
			this.ctx.strokeStyle = '#cccccc';
			this.ctx.lineCap = 'round';
			this.ctx.lineWidth = 1 * this.dpi;

			while (x <= 1) {
				step[2]+= (0.005 * (step[4])) * this.timeRatio;
				if(this.w < this.h) {
					step[4] = gsap.utils.mapRange(0,1,0.8,1,stepIndex / (this.linesCount - 1));
				} else {
					step[4] = gsap.utils.mapRange(0,1,0.4,1,stepIndex / (this.linesCount - 1));
				}

				if(stepIndex == 0 && x == 0) {
					// console.log(step[2]);
				}

				let xPos = x * this.w;
				let yPos = (step[1]) * this.h;

				let noise = this.complexNoise(
					xPos / this.w,
					yPos + step[3]/ this.h,
					this.deltaTime*0.05
				);

				let timedNoise = this.complexNoise(
					xPos / this.w,
					yPos + step[3]/ this.h,
					100 + (this.deltaTime * 0.1)
				);

				yPos += step[2];
				
				let absNoise = 0.2 + noise/2;				
				let direction = 1;
		
				let margin = 0;
				let directionX = 0;
				let directionY = 1;

				this.ctx.globalAlpha = gsap.utils.mapRange(this.h * this.yStart,this.h * this.yAlphaOffset,0,1,yPos);

				yPos += noise * this.offset;

				if(stepIndex == 0) {
					// console.log(timedNoise)
				}

				if(timedNoise > 0.3 && x > 0) {
					// return;
				} else {
					// if(x == 0) {
					// 	this.ctx.moveTo(xPos,yPos + noise * this.offset);
					// } else {
					// 	this.ctx.moveTo(lastPosition[0],lastPosition[1]);
					// }
					this.ctx.lineTo(
						xPos +
							
								(this.offset) *
								timedOffset *
								directionX,
						yPos
					);
					this.ctx.lineTo(
						xPos +
							this.gapWidth * direction +
							
								(this.offset) *
								timedOffset *
								directionX,
						yPos
					);
					lastPosition = [
						xPos +
							this.gapWidth * direction +
							(this.offset) *
							timedOffset *
							directionX,
						yPos
					];
				}
				
				x = x + (1/this.steps);
			}

			this.ctx.stroke();
			this.ctx.closePath();
		});
		this.iterator++;
	}

	resize() {
        if (this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
	}

	resizeDebounce(firstHit = false) {

		if(!firstHit) {
			if(this.isMobile && this.bcr.width == this.el.getBoundingClientRect().width) {
				return;
			}
		}

		this.dpi = 1;

		this.bcr = this.el.getBoundingClientRect();
		this.w = this.bcr.width * this.dpi;
		this.h = this.bcr.height * this.dpi;

		this.bw = this.bcr.width;
		this.bh = this.bcr.height;

		this.canvas.width = this.w;
		this.canvas.height = this.h;
		this.canvas.style.width = `${this.bw}px`;
		this.canvas.style.height = `${this.bh}px`;
		this.initLines();

	}

	complexNoise(x, y, z, pLayers, pAmplitude) {
		let xFrequency = this.xFrequency;
		let yFrequency = this.yFrequency;
		let layers;

		if(pLayers == undefined) {
			layers = 4;
		} else {
			layers = pLayers;
		}
	
		let amplitude;
		if(pAmplitude == undefined) {
			amplitude = 1;
		} else {
			amplitude = pAmplitude;
		}
	
		let value = 0;
	
		for (let i = 0; i < layers; i++) {
			const offsetX = 1;
			const offsetY = 1;
	
			value +=
				noise3D((x + offsetX) * xFrequency, (y + offsetY) * yFrequency, z) *
				amplitude;
	
			// Ajustez la fréquence et l'amplitude pour chaque couche
			xFrequency *= 2;
			yFrequency *= 2;
			amplitude *= 0.5;
		}
	
		return value;
	}

	destroy() {
		this.unregisterRAF();
		window.removeEventListener('resize', this.bindResize);
	}
}
